import { type Path, useNavigate } from '@exam-management/router';
import { QuestionCreationWorkflowStepCodeObject } from '@exam-management/task-management';
import { type ButtonProps } from '@shared/components';
import { matchPath, useLocation } from 'react-router-dom';

import { MenuButton } from '../../components';
import { useQuestionCreationTaskDetails } from '../../providers';

import { getQuestionCreationMenu } from './utils';

export default function QuestionCreationMenuButton(props: Readonly<ButtonProps>) {
  const { task, roles, status } = useQuestionCreationTaskDetails();

  const navigate = useNavigate();
  const location = useLocation();

  const matchedTaskManagement = matchPath('/task-management/*', location.pathname);
  const pathPrefix = matchedTaskManagement ? 'task-management' : 'my-task';

  if (status.code !== QuestionCreationWorkflowStepCodeObject.QuestionCreationInProgress) {
    return null;
  }

  // Only Assignee can add question but Owner cannot add question while some owner can also be assignee
  if (roles.isOwner && !roles.isAssignee) {
    return null;
  }

  const singleCurrentProgress = task.metadata?.requirement?.questionCreationCount ?? 0;
  const singleCondition = task.metadata?.requirement?.requiredQuestionCount ?? 0;

  const options = getQuestionCreationMenu(
    singleCurrentProgress,
    singleCondition,
    task.metadata?.requirement.itemSetCreation ?? [],
    task.metadata?.requirement.itemSetCondition ?? [],
    pathPrefix,
  );

  const shouldDisableMenu = options.every((option) => option.disabled);

  return (
    <MenuButton
      options={options.map((option) => ({
        label: option.label,
        disabled: option.disabled,
        onClick: () =>
          navigate(option.path as Path, {
            params: { taskId: task.id },
          }),
        slotProps: {
          tooltip: {
            title: 'ครบตามจำนวนที่กำหนดแล้ว',
            placement: 'left',
            disableHoverListener: !option.disabled,
          },
        },
      }))}
      disabled={shouldDisableMenu}
      {...props}
    >
      Add Question
    </MenuButton>
  );
}
